import React from "react";
import { Location } from "../Location";
import { IframeContent } from "./shared/IframeContent";
import { store } from "@store";
import { environment } from "../../../environments/environment";

interface Params {
  bookingId: string;
}

export class SubcontractorFormLocation extends Location<Params> {
  constructor(bookingId: string) {
    super({ bookingId });
    (window as any).onmessage = (event) => {
      this.navigation.lockNavigation(
        "customerInvoiceSlider",
        event.data === "isModified:True"
      );

      if (event.data === "shouldClose") {
        this.navigation.close();
        store().snackbars.success("Betalningsformulär har sparats.");
      }
    };
  }

  render() {
    const { bookingId } = this.params;

    return (
      <IframeContent
        url={`${environment.timereportClientUrl}/subcontractor-form/${bookingId}`}
      />
    );
  }

  toURI() {
    const { bookingId } = this.params;
    return `/bookings/${bookingId}/subcontractor-form`;
  }
}
